module.exports = __webpack_public_path__ + "94122d636eda54b81915b91f05153840.jpg";